import api from '../../../config/Config'
import { page404 } from "../../../components/icons"


const ErrorPage = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: '#f5f5f5',
        }}>
            <img src={page404} alt="Page non trouvée" style={styles.image} />
            <div style={{
                
                justifyContent: 'center'
            }}>
            <h6 style={styles.text}>Please contact the administrator for more information</h6>
            </div>
            
            <div style={{
                borderRadius: 100, border: '1px solid #1152D9', marginTop: 5, textAlign: 'center', display: 'flex',
                justifyContent: 'center', cursor: 'pointer',
            }} onClick={() => api.RedirectionLogin()}>
                <div>
                    <div style={{ color: '#1576ED', padding: 10 }}>Or log in to your account</div>
                </div>
            </div>
        </div>
    );
};

const styles = {

    image: {
        width: '400px',
    },
    text: {
        fontSize: '16px',
        color: '#333',
        
    },
};

export default ErrorPage;